import React from 'react';
import classnames from 'classnames';

import styles from './checkbox.styl';

/**
 * @property props.stopTrigger - need for case, when onClick handler placed on parent
 * due to browser behavior when user click to label, a click event will automatically
 * be triggered on the <input>, so the outer div receives 2 events
 */
export default (props) => {
  const labelClassName = classnames(
    styles.container,
    props.className,
    { [styles.disabled]: props.disabled },
    { [styles.filter_checked]: props.filterChecked },
  );

  return (
    <label onClick={(e) => { if (props.stopTrigger) e.preventDefault(); }} className={labelClassName}>
      <input type="checkbox" checked={props.checked} disabled={props.disabled} name={props.name} onChange={props.onChange} />
      <i />
      <span>{props.children}</span>
    </label>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Checkbox/index.jsx